import { Pipe, PipeTransform } from '@angular/core';
/**
 * RoundPipe transforma un número a un string, redondeándolo a dos decimales.
 *
 * Uso:
 *   value | round
 *
 * Ejemplo:
 *   {{ 65.69999999999999 | round }}
 *   formato: "65.70"
 */
@Pipe({ name: 'roundNumber' })
export class RoundNumberPipe implements PipeTransform {
  transform(value: number): string {
    return value.toFixed(2);
  }
}
